import { cn } from "@/lib/utils";

// The CareSuper lockup for the signup screens.
//
// This was previously an inline SVG recreation — an approximation drawn by
// hand because no hosted image existed at the time. One now does: the same
// caresuper-logo.png the hosted Universal Login screens use
// (auth0_branding.logo_url and the theme's widget.logo_url), so signup and the
// login/MFA/reset screens either side of it show an identical mark instead of
// two similar-but-different ones.
//
// SERVED FROM THE ACUL ORIGIN, NOT THE PORTAL. The hosted UL screens point at
// https://app.azuremark.co/caresuper-logo.png, which ties them to the portal
// container and the tunnel being up (see ARCHITECTURE.md). Pointing these
// screens at that same URL would import that fragility into the signup journey
// for no benefit, so the image is committed to acul/public/ and served from
// Cloudflare Pages alongside the rest of the bundle — same bytes, same CDN,
// same availability as the code that renders it.
//
// The URL is derived from the bundle's own location rather than hardcoded, so
// it follows var.acul_asset_base_url automatically: repoint the head_tags at
// supersystem-acul.pages.dev to isolate a DNS problem and the logo follows,
// rather than being the one asset still pinned to the old host. A relative
// path would NOT work here — the page is served from auth.azuremark.co, so
// "/caresuper-logo.png" would resolve against Auth0's domain.
const LOGO_URL = new URL("/caresuper-logo.png", import.meta.url).href;

export default function CareSuperLogo({ className }: { className?: string }) {
  return (
    <img
      src={LOGO_URL}
      alt="CareSuper"
      // `self-start object-contain` is not decoration — without it this
      // renders STRETCHED, and the swap from SVG to <img> is exactly what
      // exposed it. Both call sites in JourneyLayout put the logo in a COLUMN
      // flex container, whose default `align-items: stretch` pulls items to
      // the full cross-axis width (224px in the desktop sidebar). The old SVG
      // shrugged that off because a viewBox preserves aspect ratio inside
      // whatever box it is given; an <img> defaults to `object-fit: fill` and
      // simply distorts. Caught live: 224x40 rendered from a 500x246 source,
      // where the correct width at h-10 is 81px.
      //
      // `self-start` restores intrinsic sizing (width: auto actually behaving
      // as auto); `object-contain` means a future layout change cannot
      // reintroduce the distortion silently.
      //
      // Merged with cn() so a caller's own sizing classes still win — the
      // props contract is unchanged from the SVG version.
      className={cn("self-start object-contain", className ?? "h-12 w-auto")}
    />
  );
}
